module.exports = __webpack_public_path__ + "static/media/A5.6494b2d5.jpg";